import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { BUSINESS_NAME, PHONE_DISPLAY } from "@/data/site";

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms & Website Policies | Authentically Yours Property Services"
        description="Terms of use for the Authentically Yours Property Services LLC website and estimate requests."
        path="/terms"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Terms", path: "/terms" },
        ]}
      />
      <PageHero
        eyebrow="Legal"
        title="Terms & Website Policies"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Terms", path: "/terms" },
        ]}
      />
      <div className="container-x py-16 sm:py-24 max-w-3xl space-y-6 text-ink/75 leading-relaxed">
        <p>
          Welcome to the {BUSINESS_NAME} website. By using this site you agree to the
          following terms.
        </p>
        <h2 className="text-2xl text-ink pt-4">Estimates & Information</h2>
        <p>
          Information on this website is provided for general informational purposes.
          Service descriptions, scopes and availability may vary by property. Any
          estimate provided is based on the details and photos you share and may be
          adjusted after an on-site assessment.
        </p>
        <h2 className="text-2xl text-ink pt-4">Pricing</h2>
        <p>
          Pricing is provided through free estimates and custom quotes. This website
          does not represent binding prices.
        </p>
        <h2 className="text-2xl text-ink pt-4">Junk Removal Limitations</h2>
        <p>
          We do not accept hazardous or regulated materials. Please contact us with
          questions about specific items before your service.
        </p>
        <h2 className="text-2xl text-ink pt-4">Contact</h2>
        <p>
          Questions about these terms? Call or text us at {PHONE_DISPLAY}. These terms
          may be updated from time to time.
        </p>
      </div>
    </>
  );
}
